var _rect, _rect2, _rect3, _rect4, _circle, _circle2, _line, _text, _path, _rect5, _circle3, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoSlots(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 10,
    width: 30,
    height: 22,
    rx: 3,
    fill: "#1e293b",
    stroke: "#8b5cf6",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 13,
    width: 7,
    height: 13,
    rx: 1.5,
    fill: "#0f172a",
    stroke: "#6366f1",
    strokeWidth: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 13,
    width: 7,
    height: 13,
    rx: 1.5,
    fill: "#0f172a",
    stroke: "#6366f1",
    strokeWidth: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 13,
    width: 7,
    height: 13,
    rx: 1.5,
    fill: "#0f172a",
    stroke: "#6366f1",
    strokeWidth: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 17,
    r: 1.5,
    fill: "#ef4444"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 19.5,
    r: 1.5,
    fill: "#ef4444"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    y1: 19,
    x2: 11.5,
    y2: 17,
    stroke: "#22c55e",
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 17.5,
    y: 23,
    fontFamily: "Arial",
    fontSize: 8,
    fontWeight: "bold",
    fill: "#f59e0b"
  }, "7")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 16 L29.5 19 L32.5 19 L30 21 L31 24 L28.5 22.3 L26 24 L27 21 L24.5 19 L27.5 19Z",
    fill: "#f59e0b"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 14,
    width: 2.5,
    height: 10,
    rx: 1.25,
    fill: "#475569"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.25,
    cy: 13,
    r: 2.5,
    fill: "#ef4444"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 20,
    x2: 32,
    y2: 20,
    stroke: "#fbbf24",
    strokeWidth: 0.75,
    strokeDasharray: "2 1",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoSlots);
export default __webpack_public_path__ + "static/media/video-slots.63293052fd39ddd590b00d3def787ce1.svg";
export { ForwardRef as ReactComponent };